import React, { useContext, useEffect } from 'react'
import Template from 'Components/Templates/Template';
import { useState } from 'react';
import { PROFESSIONALTAB, assistantAdminProfilePanelItems, assistantProfilePanelItems, getAssistantReqApi, premiumProfCasesPanelItems, premiumProfCasesPanelItemsOnAsst, profCasesPanelItems, profCasesPanelItemsOnAsst } from 'Constants';
import CasesFeedContent from './AllCases';
import CasesPanelRedirect from './CasesPanelRedirect';
import { Context } from 'Context/Context';
import AssociatesCasesPage from './AssociatesCasesPage';
import HeaderMenuItems from 'Components/Header/HeaderMenuItems';
import SearchBox from 'Components/Header/SearchBox';
import SearchContentProf from 'Components/Header/SearchContentProf';
import Header from 'Components/Header/Header';
import { Link } from 'react-router-dom';
import CloseIcon from 'Components/Icons/CloseIcon';
import { BiSolidRightArrow } from 'react-icons/bi';
import useIsMobile from 'Hooks/useIsMobile';
import SidePanelMobile from './SidePanelMobile';
import { Menu } from 'lucide-react';

function CasesFeed({attorney, setLoadProfile, associateCount, setAssociateCount}) {
  const {userDetails, makeApiCallFunc} = useContext(Context);
  const [openMenu, setOpenMenu] = useState(false);
  const isMobile = useIsMobile();
  const [showAssistantReq, setShowAssistantReq] = useState(true);

  const userInfo = attorney ? attorney?.userId :  userDetails;
  const {selectedMenuItem} = useContext(Context);
  const [assistantReqList, setAssistantReqList] = useState(null);
 

  const [updateComp, setUpdateComp] = useState(true);
  
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  let sideBarItems = attorney ?
   (attorney?.userId?.isActiveSubscription ?
    premiumProfCasesPanelItemsOnAsst
    :
    profCasesPanelItemsOnAsst)
    :
    (
    userDetails?.isActiveSubscription ?
    premiumProfCasesPanelItems
    :
    profCasesPanelItems
    )
  const [showAllProfile, setShowAllProfile] = useState(userDetails?.isUserAssistant && !attorney);
  useEffect(() => {
    if(!userDetails?.isUserAssistant)
    {
      // background count for the menu badge - no full-page loader for it
      makeApiCallFunc(getAssistantReqApi, null, ({data}) => {
        setAssistantReqList(data.assistantReqCount);
      },() => {}, null, true)
    }
  }, []);
  useEffect(()=> {
    if(attorney)
    {
      sideBarItems.map((item, index) => {
        if(item.key === '5')
        {
          item['count'] = associateCount;
        }
        return item;
      });
     
    }
  },[associateCount, attorney]);

  return (
    <>
      
    {
      showAllProfile ? 
      <>
        <Header setUpdateComp={setUpdateComp}/>  
      <AssociatesCasesPage/>
      </>
      :
      <>
        {
          attorney ?
          <>
          <div className=' z-10 col-span-6 h-[40px]  w-full bg-white text-gray-700  pt-4 flex items-center justify-between h-12 px-4 '>
            <div className="w-full flex items-center justify-left flex ">
              <div className='text-gray-600 flex items-center text-xs lg:text-sm w-full'  onClick={(e) => setLoadProfile(null)}>
                <div className='underline w-max cursor-pointer'>
                  Case Profile List
                  </div>
                <BiSolidRightArrow className='mx-2  w-[10px] h-[10px]  '/>
                <div className='text-gray-600 w-max underline cursor-pointer '>
                 Case Profile of {attorney?.userId?.firstName} {attorney?.userId?.lastName}
                 </div>
                 </div>

            </div>
               <div className="w-full" />

          </div>
          <div className='col-span-6 flex border border-b-1 border-t-0 border-r-0 border-l-0    justify-between shadow-lg items-center h-[60px]'>
              {
                isMobile ?
                <SidePanelMobile openMenu={openMenu} setOpenMenu={setOpenMenu} content={
                  <HeaderMenuItems 
                  renderHorizontal={false}
                  menuItems = {
                    attorney?.userId?.isActiveSubscription ?
                      premiumProfCasesPanelItemsOnAsst
                      :
                      profCasesPanelItemsOnAsst} userInfo={attorney?.userId} setOpenMenu={setOpenMenu} />
                } />
                :
                <HeaderMenuItems menuItems = {
                  attorney?.userId?.isActiveSubscription ?
                  premiumProfCasesPanelItemsOnAsst
                  :
                  profCasesPanelItemsOnAsst} userInfo={attorney?.userId} />
              }
              <div className='w-full flex gap-2 items-center justify-center border-t-1 lg:items-end lg:justify-start'>
                <div className='flex justify-center items-center px-2 '>
                  <Menu onClick={() => setOpenMenu(true)} className='w-5  h-5 text-gray-600 cursor-pointer lg:hidden' />
                </div>
              <SearchContentProf attorney={attorney} size="l" setUpdateComp={setUpdateComp}/>
                </div>
          </div>
         
          </>
          :
          <>
          <Header
           setUpdateComp={setUpdateComp}
           caseList={true}
          />
          {assistantReqList > 0 && showAssistantReq &&
            <div className='col-span-6 flex py-2.5 text-xs lg:text-[13px] px-4 lg:px-7 justify-between items-center font-plexsans bg-brass/[.1] border-b border-brass/[.25] text-navy'>
               <div className='lg:flex items-center'>
               You have {assistantReqList} request(s) from legal assistant(s) to represent you. <Link to="/attorney/profile/4" className='underline ml-2 cursor-pointer font-semibold text-brass'>View the requests</Link>
                </div>
                <div onClick={() => setShowAssistantReq(false)} className='cursor-pointer'>
               <CloseIcon />

                </div>
            </div>
          }
          </>
        }
        
        
        {/* Case list: each section renders its own left case-type panel + filter bar */}
        <div className='col-span-6 w-full'>
        <CasesPanelRedirect 
        attorney={attorney}
        showModal={showModal} 
        setShowModal={setShowModal} 
        setAssociateCount={setAssociateCount} 
        updateComp={updateComp} 
        setUpdateComp={setUpdateComp}/>
        </div>
      </>
    }
    </>
  )
}

export default CasesFeed